import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import moment from 'moment-timezone';
import configureStore from './store';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import * as API from './api/coiApi';
import './index.css';

moment.tz.setDefault("UTC");

const store = configureStore();

API.setupInterceptors(store);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
